import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { Card, CardContent, Grid, Icon, Tooltip } from '@mui/material'
import { isNil } from 'lodash'
import { MAIN_RADIUS } from 'utils/constants/Theme'

const SimpleTabList = ({
    defaultTab,
    controlTab,
    setControlTab,
    tabs = [],
    children,
    noPadding = false,

    headerComponent,
    sx = {},
    absoluteTabs = false,
    borderRadius = MAIN_RADIUS,
}) => {
    const [tab, setTab] = useState(defaultTab ?? tabs[0]?.constant)

    if (isNil(controlTab) + isNil(setControlTab) === 1) { // one is undefined and the other is defined
        // eslint-disable-next-line no-console
        console.error('controlTab and setControlTab must both be defined if you want to control the behavior')
    }

    const currentTab = controlTab ?? tab
    const setCurrentTab = setControlTab ?? setTab

    const tabStyle = absoluteTabs ? { position: 'absolute', right: `calc(${borderRadius} + 1px)`, top: '-49px' } : { marginRight: `calc(${borderRadius} + 1px)` }

    return (
        <Grid container columnSpacing={1} alignItems='flex-end' sx={sx}>
            <Grid size='grow' sx={{ paddingBottom: headerComponent ? '8px' : undefined }}>
                {headerComponent}
            </Grid>
            <Grid container size='auto' columnSpacing={0.5} sx={tabStyle}>
                {tabs.map(({ label, icon, constant }) => {
                    const isCurrent = constant === currentTab
                    return (
                        <Grid key={constant} size='auto' sx={{ zIndex: 1 }}>
                            <Tooltip title={label}>
                                <div
                                    style={{
                                        backgroundColor: isCurrent ? 'white' : '#f0f0f0',
                                        borderRadius: '8px 8px 0 0',
                                        textAlign: 'center',
                                        display: 'flex',
                                        boxShadow: '0px -1px 2px 0px rgba(0,0,0,0.05)',
                                        cursor: 'pointer',
                                        padding: '10 22',
                                    }}
                                    onClick={() => {
                                        if (!isCurrent) {
                                            setCurrentTab(constant)
                                        }
                                    }}
                                    data-cy={`tab-${constant}`}
                                >
                                    <Icon fontSize='large' sx={{ color: isCurrent ? 'black' : '#333' }}>{icon}</Icon>
                                </div>
                            </Tooltip>
                        </Grid>
                    )
                })}
            </Grid>
            <Grid size={12}>
                <Card borderRadius={borderRadius}>
                    <CardContent padding={noPadding ? '0' : undefined}>
                        {children(currentTab)}
                    </CardContent>
                </Card>
            </Grid>
        </Grid>
    )
}

SimpleTabList.propTypes = {
    defaultTab: PropTypes.string.isRequired,
    controlTab: PropTypes.string,
    setControlTab: PropTypes.func,
    tabs: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string,
        icon: PropTypes.string,
        constant: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    })).isRequired,
    children: PropTypes.func.isRequired,
    noPadding: PropTypes.bool,

    headerComponent: PropTypes.element,
    sx: PropTypes.shape({}),
    absoluteTabs: PropTypes.bool,
    borderRadius: PropTypes.string,
}

export default SimpleTabList
